<template>
  <div class="flex flex-column flex-grow-1" :class="`${AppConfig.theme}-theme`">
    <label v-if="props.label" class="label-top">{{ props.label }}</label>
    <div class="flex p-float-label">
      <Calendar
        v-model="v$.value.$model"
        v-bind="$attrs"
        dateFormat="dd/mm/yy"
        showIcon
        class="flex-grow-1"
        touchUI
        :manualInput="false"
        :minDate="props.minDate"
        :maxDate="props.maxDate"
        :disabled="props.readonly"  
      />
      <label v-if="props.label" class="label-border">{{ props.label }}</label>
    </div>
    <div class="flex">
      <small v-if="v$.value.$error" id="date_range-help" class="p-error">Date is required</small>
      <small v-if="v$.value.$error == [] && props.required" class="help-text">*{{ t('general.required') }}</small>
    </div>
  </div>
</template>
<script setup>
import { computed, watch } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'
import AppConfig from '~/config/appConfig.js'

const props = defineProps({
  label: {
    type: String,
    default: null
  },
  required: Boolean,
  maxDate: Date,
  minDate: Date,
  readonly: {
    type: Boolean,
    default: false
  }
})

const modelValue = defineModel()

const { t } = useI18nUtils()
const value = computed({
  get() {
    if (modelValue.value == undefined) return null
    const date = new Date(modelValue.value)
    return isNaN(date.getDate()) ? null : date
  },
  set(newVal) {
    modelValue.value = newVal
  }
})

watch(value, (newVal) => {
  if (newVal instanceof Date &&
      newVal.getHours() === 0 && 
      newVal.getMinutes() === 0 && 
      newVal.getSeconds() === 0 && 
      newVal.getMilliseconds() === 0) {
    const now = new Date()
    const adjustedDate = new Date(newVal)
    adjustedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds())
    value.value = adjustedDate
  }
})

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>

<style scoped>
span {
  margin: 0;
}

i {
  margin: 0;
}

label {
  font-weight: 550;
  color: #013315;
}

.label-top {
  margin-bottom: 8px;
  display: none;
}

@media screen and (min-width: 768px) {
  .label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }
  .label-top {
    display: block;
  }

  .label-border {
    display: none;
  }
}

.p-calendar {
  box-shadow: 1px 2px 4px #00000029 !important;
  border: 0.5px solid #E5E5E5 !important;
  border-radius: 8px !important;
}

.sbg-theme {
  label {
    color: rgba(0, 0, 0, 0.6);
    font-weight: normal;
    width: auto;
  }

  .label-top {
    display: none;
  }

  .label-border {
    display: block;
  }

  .p-focus ~ label {
    color: #00afa5;
  }

  :deep(.p-calendar) {
    border-radius: 8px;
    height: auto;
    line-height: normal;
    box-shadow: none !important;
    border: 1px solid rgba(0, 0, 0, 0.38) !important;
  }

  .p-calendar:focus {
    box-shadow: inset 0 0 0 1px #00afa5, inset 0 0 0 1px #00afa5, inset 0 0 0 1px #00afa5, inset 0 0 0 1px #00afa5;
  }

  :deep(.p-icon) path {
    fill: var(--primary-color) !important;
  }
}

</style>
